/**
 * @flow
 * @relayHash d6a2ca96d9f3b286d113dc2c83e335b1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type QuotationSupplierCreateInput = {|
  num: string,
  title: string,
  description?: ?string,
  address: string,
  date: any,
  tax?: ?string,
  discountType?: ?string,
  discountValue?: ?string,
  total: string,
  totalTTC: string,
  currencyId: string,
  supplierId: string,
  quotationSupplierItem: $ReadOnlyArray<QuotationSupplierItemCreateInput>,
|};
export type QuotationSupplierItemCreateInput = {|
  designation: string,
  description?: ?string,
  quantity: string,
  unityId: string,
  discount?: ?string,
  unitPrice: string,
  total: string,
|};
export type CreateQuotationSupplierMutationVariables = {|
  data: QuotationSupplierCreateInput
|};
export type CreateQuotationSupplierMutationResponse = {|
  +createQuotationSupplier: {|
    +id: string
  |}
|};
export type CreateQuotationSupplierMutation = {|
  variables: CreateQuotationSupplierMutationVariables,
  response: CreateQuotationSupplierMutationResponse,
|};
*/


/*
mutation CreateQuotationSupplierMutation(
  $data: QuotationSupplierCreateInput!
) {
  createQuotationSupplier(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "QuotationSupplierCreateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createQuotationSupplier",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "QuotationSupplierModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateQuotationSupplierMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateQuotationSupplierMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateQuotationSupplierMutation",
    "id": null,
    "text": "mutation CreateQuotationSupplierMutation(\n  $data: QuotationSupplierCreateInput!\n) {\n  createQuotationSupplier(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3f5f47f29b371106083a3b6fca1e7c7d';
module.exports = node;
